import { Buffer } from 'buffer';

export const cryptDecode = (input, HIBA_SALT) => {
  console.log('* decrypting hiba...');
  const key = HIBA_SALT;
  let result = '';

  const string = Buffer.from(input, 'base64').toString('binary');

  for (let i = 0; i < string.length; i++) {
    let char = string.substr(i, 1);
    let keychar = key.substr((i % key.length) - 1, 1);
    char = String.fromCharCode(char.charCodeAt(0) - keychar.charCodeAt(0));
    result += char;
  }

  return result;
};
